<!--
Created on 2021-04-16
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-16
-->
<template>
  <table class="table table-borderless text-center rounded-sm shadow-l" style="overflow: hidden;">
    <thead>
      <tr>
        <th scope="col" class="bg-dark-dark border-dark-dark color-white">Názov</th>
        <th scope="col" class="bg-dark-dark border-dark-dark color-white">Cel.</th>
        <th scope="col" class="bg-dark-dark border-dark-dark color-white">Zmen.</th>
        <th scope="col" class="bg-dark-dark border-dark-dark color-white">Nové</th>
        <th scope="col" class="bg-dark-dark border-dark-dark color-white">Zmaz.</th>
      </tr>
    </thead>
    <tbody>
      <tr class="bg-dark-light">
        <th scope="row">Zákanzíci</th>
        <td>{{ customerCount.all || '-' }}</td>
        <td>{{ customerCount.modified || '-' }}</td>
        <td>{{ customerCount.new || '-' }}</td>
        <td>{{ customerCount.removed || '-' }}</td>
      </tr>
      <tr class="bg-dark-light">
        <th scope="row">Objednávky</th>
        <td>{{ orderCount.all || '-' }}</td>
        <td>{{ orderCount.modified || '-' }}</td>
        <td>{{ orderCount.new || '-' }}</td>
        <td>{{ orderCount.removed || '-' }}</td>
      </tr>
      <tr class="bg-dark-light">
        <th scope="row">Distribútori</th>
        <td>{{ distribCount.all || '-' }}</td>
        <td>{{ distribCount.modified || '-' }}</td>
        <td>{{ distribCount.new || '-' }}</td>
        <td>{{ distribCount.removed || '-' }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { ref } from 'vue'
import storage from '@/lib/storage'

export default {
  name: 'DataCountersTable',
  setup() {
    const customerCount = ref({ all:'-', new:'-', modified:'-', removed:'-'})
    const distribCount = ref({ all:'4', new:'-', modified:'-', removed:'-'})
    const orderCount = ref({ all:'-', new:'-', modified:'-', removed:'-'})

    function getData() {
      Promise.all([
        storage.getAllCustomers()
      ])
        .then(data => {
          // customers
          const customers = data[0]
          let countM = 0
          let countN = 0
          let countZ = 0
          customers.forEach(item => {
            if (item.addedTime) countN++
            if (item.deletedTime) countZ++
            if (item.updatedTime) countM++
          })
          customerCount.value = {
            all: customers.length,
            new: countN,
            modified: countM,
            removed: countZ,
          }
        })
    }

    return {
      getData,
      customerCount,
      orderCount,
      distribCount,
    }
  },
  mounted() {
    this.getData()
  }
}
</script>


<style>

</style>